import axios from 'axios'

/**
 * 获取文件Blob
 * @param url
 * @param onProgress
 * @returns
 */
export const getFileBlob = (url: string, onProgress?: (num: number) => void) => {
  return new Promise((resolve: (value: Blob) => void, reject) => {
    axios({
      url,
      method: 'get',
      headers: { 'Cache-Control': 'no-cache' },
      responseType: 'blob',
      onDownloadProgress: (e) => {
        onProgress && onProgress(Number(((e.loaded / e.total) * 100).toFixed(2)))
      }
    }).then(res => {
      resolve(res.data as Blob)
    }).catch(err => {
      console.error(err)
      reject(err)
    })
  })
}
